import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TimeService } from "@app2/shared/services/time.service";

@Component({
    selector: "timezone-picker",
    template: `
        <ds-select [selectedOption]="timezone"
                   [disabled]="disabled"
                   [options]="timezones | mapStringToPair"
                   (selectedOptionChange)="timezoneChange.emit($event)"
                   test-id="timezone-select">
        </ds-select>
    `,
})
export class TimezonePickerComponent {
    @Input() timezone: string;
    @Input() disabled: boolean;
    @Output() timezoneChange = new EventEmitter<string>();

    timezones: string[];

    constructor(public timeService: TimeService) {
        this.timezones = this.timeService.zoneNames;
    }
}
